module.exports = __webpack_public_path__ + "static/media/main_card02_n.ed97bcc3.png";